import { useState, useEffect } from "react";
import { useAppSelector } from "../redux";

export type OrganizationTier = "enterprise" | "developer";

export const useAuth = () => {
  const [user, setUser] = useState<any>(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [organizationTier, setOrganizationTier] = useState<OrganizationTier | null>(null);

  const sessionUser = useAppSelector((state) => state.session.user);
  const selectedOrganizationId = useAppSelector((state) => state.session.selectedOrganizationId);

  const effectiveOrganizationId = sessionUser?.isAdmin && selectedOrganizationId ? selectedOrganizationId : sessionUser?.organizationId;

  const tier = useAppSelector((state) => {
    if (effectiveOrganizationId) {
      return state.organization.entities[effectiveOrganizationId]?.tier || null;
    }
    return null;
  });

  useEffect(() => {
    if (sessionUser) {
      setUser(sessionUser);
      setIsAdmin(sessionUser.isAdmin);
    } else {
      setUser(null);
      setIsAdmin(false);
    }
  }, [sessionUser]);

  useEffect(() => {
    setOrganizationTier((tier as OrganizationTier) || null);
  }, [tier]);

  return { user, isAdmin, organizationTier };
};
